/* eslint-disable */
import axios from 'axios'
import getKlaviyoData from './klaviyo-product-data'
import { getFormattedMoneyString, getLocalURL } from './globale'
import getVideeoData from './videe-product-data'

const updateQuantity = (cartItems, cartItemRes) => {
  if (cartItemRes) {
    cartItems.forEach(item => {
      const qtySelectorValue = item.querySelector('.js-qtySelectorValue')
      const totalSalePriceValue = item.querySelector('.js-totalSalePrice .currency-formatting')
      qtySelectorValue.textContent = cartItemRes.quantity

      totalSalePriceValue.textContent = getFormattedMoneyString(cartItemRes.line_price)
    })
  } else {
    cartItems.forEach(item => item.remove())
  }
}

const updateCartTotals = (data) => {
  const totals = document.querySelectorAll('.js-cartTotal .currency-formatting')
  const count = document.querySelector('.js-cartCount')
  const cartPageCount = document.querySelector('.js-cartPageCount')
  const miniCart = document.querySelector('.js-miniCart')
  const cartSubmits = document.querySelectorAll('.js-cartSubmit')

  totals.forEach(total => {
    total.textContent = getFormattedMoneyString(data.total_price)
  })
  count.textContent = data.item_count

  if (cartPageCount) {
    cartPageCount.textContent = `${data.item_count} item${data.item_count === 1 ? '' : 's'}`
  }

  if (data.item_count === 0) {
    miniCart.classList.add('emptyCart')
    cartSubmits.forEach((btn) => {
      btn.disabled = true
    })
  } else {
    miniCart.classList.remove('emptyCart')
    cartSubmits.forEach((btn) => {
      btn.disabled = false
    })
  }
}

const triggerProductAddedEvents = (productId, upsell) => {
  const productAdded = new Event('productadded')
  document.dispatchEvent(productAdded)

  const toggleMiniCart = new Event('toggleMiniCart')

  if (!upsell) {
    document.dispatchEvent(toggleMiniCart, { upsell })
  }

  window.basis.EventBus.emit('product-added', { productId })
}

const updateVideeo = (productId, quantity) => {
  const videeoData = getVideeoData(productId)
  window.videeoCommand('config', { shopName: videeoData.shopName })
  window.videeoCommand('addToCart', { product: { ...videeoData.data, quantity } })
}

const pushKlayyio = (productId) => {
  const klaviyoData = getKlaviyoData(productId)
  window._learnq.push(['track', 'Added to Cart', klaviyoData])
}

const loadImages = (items) => {
  items.querySelectorAll('.js-cartItemImg').forEach(img => {
    const { src, variantId } = img.dataset
    const image = new Image()

    image.src = src
    image.addEventListener('load', () => {
      const mountedImg = document.querySelector(`.js-cartItemImg[data-variant-id="${variantId}"]`)
      mountedImg.setAttribute('src', src)
      mountedImg.setAttribute('data-loaded', 'true')
    })
  })

  document.querySelector('.js-miniCartItems').innerHTML = items.innerHTML
}

const getCart = async() => {
  try {
    const { data } = await axios.get(getLocalURL('/cart.js'))
    return data
  } catch (error) {
    console.log('Error fetching cart data', error)
  }

  return false
}

const addProduct = async(productId, variantId, quantity, properties = {}, upsell = false) => {
  try {
    // temporary fix for adding more than 5 items
    const parsedVariantId = parseInt(variantId)
    const currentCart = await getCart()
    const existingItem = currentCart.items.find(item => item.variant_id === parsedVariantId)
    const existingQuantity = existingItem ? existingItem.quantity : 0
    const allowedQuantity = Math.min(quantity, 5 - existingQuantity)

    if (allowedQuantity <= 0) {
      console.log('Cannot add more of this item, limit reached.')
      return
    }

    const postItems = {
      items: [
        {
          quantity: allowedQuantity,
          id: parsedVariantId,
          properties,
        },
      ],
    }

    await axios.post(getLocalURL('/cart/add.js'), postItems)
    const { data } = await axios.get(getLocalURL('/cart'))
    const page = document.createElement('html')
    page.innerHTML = data
    const items = page.querySelector('.js-cartPageItems')
    const cartData = {
      total_price: parseInt(items.dataset.cartTotal),
      item_count: parseInt(items.dataset.itemCount),
    }

    loadImages(items)
    updateCartTotals(cartData)
    triggerProductAddedEvents(productId, upsell)
    pushKlayyio(productId)
    updateVideeo(productId, allowedQuantity)
  } catch (error) {
    console.log('Error adding item to cart', error)
  }
}

const updateProduct = async(id, quantity) => {
  try {
    // temporary fix for adding more than 5 items
    const allowedQuantity = Math.min(quantity, 5)

    const updates = {}
    updates[id] = allowedQuantity

    const cartItems = document.querySelectorAll(`.js-cartItem[data-variant-id="${id}"]`)
    const { data } = await axios.post(getLocalURL('/cart/update.js'), { updates })
    const cartItemRes = data.items.find(item => item.variant_id === parseInt(id))
    updateQuantity(cartItems, cartItemRes)
    updateCartTotals(data)
    window.basis.EventBus.emit('cart-updated', { data })
    return cartItemRes ? cartItemRes.quantity : 0
  } catch (error) {
    console.log('Error updating cart item', error)
  }
}

export {
  addProduct,
  updateProduct,
  getCart,
}
